import { defineStore } from 'pinia'

export const useCommonStore = defineStore({
  id: 'common',
  state: () => ({
    loader: false,
  }),
  actions: {
    loaderOn() {
      this.loader = true
    },
    loaderOff() {
      this.loader = false
    },
  },
})
